
import { Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Skeleton, Typography } from "@mui/material";
import IntlMessages from "util/IntlMessages";
import CardBox from "components/CardBox";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import { useState, useEffect } from "react";
import TitlebarImageList from "./TitlebarImageList";
import GetAppIcon from '@mui/icons-material/GetApp';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import { getUploadFileFullPath, getUploadFileFullPathDownload, sanitizePreviewHtml, stripPlainText } from "util/utilFunction";
import FileList from "./FileList";
import config from "config";
import ItemLocationMap from "./ItemLocationMap";


const ItemPreviewCard = ({item={}  , projectSettings={} ,   itemLangList=[] , selectedProject  , fileList=[] , visibility , previewRole , loading , itemMeans = "" , itemLang = null}) => {

    const [categoryName, setCategoryName] = useState("");
    const [videoFile, setVideoFile] = useState(null);

    const locationEnabled = Number(projectSettings?.locationStatus) === 1;
    const itemLat = item?.lat ?? item?.latitude ?? null;
    const itemLng = item?.lng ?? item?.longitude ?? null;
  const downloadFile = async (file, fileName="Dosya ") =>{
          fileName = fileName +" "+ config.docTypes[file.docType] + file.ext;
            getUploadFileFullPathDownload(file,fileName);
  };




    useEffect(() => {
        if(item){
            const list = selectedProject?.categoryList || [];
            const cat = list.find(x => Number(x.id) === Number(item.categoryId));
            if (!cat) {
              setCategoryName("");
              return;
            }
            const parent = cat.parentId
              ? list.find(x => Number(x.id) === Number(cat.parentId))
              : null;
            setCategoryName(parent ? `${parent.name} / ${cat.name}` : cat.name);
        }
    }, [selectedProject,item]);



  return <Card>
    <CardHeader title={stripPlainText(item.title)} />
    <CardContent>

          <div className="row">
          <CardBox
            styleName="col-md-6"
            heading={<IntlMessages id="item.information" />}
          >
            <List dense={true}>
            <Divider light />


            {selectedProject !== null  && <ListItem>
              <ListItemText
                  primary={<IntlMessages id="item.project" />}  primaryTypographyProps={{color:"secondary"}}
                  secondary={ selectedProject.name   }
                />
              </ListItem>}
              <Divider light />
     
              <ListItem>
                <ListItemText  color="teal"
                  primary={<IntlMessages id="item.title" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={stripPlainText(item.title)}
                />
              </ListItem>
              <Divider light />

              <ListItem>
                <ListItemText  color="teal"
                  primary={<IntlMessages id="item.definition" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={item.definition}
                />
              </ListItem>
              <Divider light />
              {visibility && <ListItem>
                <ListItemText
                  primary={<IntlMessages id="item.writer" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={ Array.isArray(item.writers) ? item.writers.join(" , ") : item.writers}
                />
              </ListItem>}
              <Divider light />
              {/* <ListItem>
              <ListItemText
                primary={item.projectType===1 ?  <IntlMessages id="item.langEquivalent" /> :  <IntlMessages id="item.abstract" /> } primaryTypographyProps={{color:"secondary"}}
                secondary={item.abstract}
              />
            </ListItem>
            <Divider light /> */}


              <ListItem>
              <ListItemText
                primary={<IntlMessages id="item.lang" />} primaryTypographyProps={{color:"secondary"}}
                secondary={
                  item.lang 
                    ? Array.isArray(item.lang) 
                      ? item.lang.join(",") 
                      : item.lang.replace("#",",")
                    : ""
                }
              />
            </ListItem>
            <Divider  />

              <ListItem>
                <ListItemText
                  primary={<IntlMessages id="item.keyword" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={ 
                    item.keyword
                      ? Array.isArray(item.keyword) 
                        ? item.keyword.map(keyWord=>
                            <Chip 
                              key={keyWord} 
                              disabled={!(visibility && previewRole !== "writer")} 
                              onClick={()=> visibility && previewRole !== "writer" ? history.push("/says/searchItem/"+keyWord) : null } 
                              color="primary" 
                              className="m-1" 
                              size="small" 
                              icon={<SpellcheckIcon />} 
                              label={keyWord} 
                            />
                          )
                        : item.keyword.split(",").map(keyWord=>
                            <Chip 
                              key={keyWord} 
                              disabled={!(visibility && previewRole !== "writer")}  
                              onClick={()=> visibility && previewRole !== "writer" ? history.push("/says/searchItem/"+keyWord) : null } 
                              color="primary" 
                              className="m-1" 
                              size="small" 
                              icon={<SpellcheckIcon />} 
                              label={keyWord} 
                            />
                          )
                      : ""
                  }
                />
              </ListItem>
        
              <Divider light />
          
              <ListItem>
            <ListItemText
                primary={<IntlMessages id="item.category" />} primaryTypographyProps={{color:"secondary"}}
                secondary={categoryName}
              />
            </ListItem>
            <Divider light />

            </List>

        

          </CardBox>
     
     
       </div>

       {locationEnabled && (
         <div className="row my-3">
           <CardBox styleName="col-md-12" heading="Konum">
             <ItemLocationMap lat={itemLat} lng={itemLng} title={item.title || ''} />
           </CardBox>
         </div>
       )}

       <div className="row my-3">
       <div className="col-md-6">
       <TitlebarImageList 
       title={"Görseller"}
       imageList={fileList.filter(x=>x.docType===3)}
       /> 
       </div>
       <div className="col-md-6">

       { 
   loading ? 
    <div>
       <Skeleton height={100} />
       <Skeleton height={100} />
       <Skeleton height={100} />
       <Skeleton height={100} />

    </div>
   :
   fileList.filter((file) => Number(file.docType) !== 10).length>0 &&    
         <FileList fileList={fileList.filter((file) => Number(file.docType) !== 10)} 
                    itemTitle={item.title}
                    title={<IntlMessages id="fileUpload.list.title"/>}
                    handleDeleteState={true}
                    handleDeleteIcon={<GetAppIcon/>}
                    handleDelete={( file, itemTitle)=>downloadFile(file, itemTitle)} 
                    styleName="col-md-12 alert-warning mb-2"
                    dense={true}
                    />
   }       </div>
       </div>

       {fileList.some((file) => Number(file.docType) === 10) && (
         <div className="row my-3">
           <div className="col-md-12">
             <FileList
               fileList={fileList.filter((file) => Number(file.docType) === 10)}
               itemTitle={item.title}
               title="Videolar"
               handleDeleteState={true}
               handleDeleteIcon={<span className="zmdi zmdi-play" />}
               handleDelete={(file) => setVideoFile(file)}
               styleName="col-md-12 alert-info mb-2"
               dense={true}
             />
           </div>
         </div>
       )}

       <Dialog open={Boolean(videoFile)} onClose={() => setVideoFile(null)} maxWidth="md" fullWidth>
         <DialogTitle>{videoFile?.docTypeTitle || videoFile?.originalName || "Video"}</DialogTitle>
         <DialogContent>
           {videoFile && (
             <video
               key={videoFile.id}
               controls
               autoPlay
               style={{ width: "100%", maxHeight: "70vh", background: "#000" }}
               src={getUploadFileFullPath(videoFile)}
             >
               Tarayıcı video oynatmayı desteklemiyor.
             </video>
           )}
         </DialogContent>
         <DialogActions>
           <Button onClick={() => setVideoFile(null)}>Kapat</Button>
         </DialogActions>
       </Dialog>
      
    
   {projectSettings.privateColumnStatus === 1 && <div className="row">
      <CardBox
        styleName="col-md-12 col-12"
        heading={ projectSettings.privateColumnName}
      >
    
          <span
            className="card-text"
            dangerouslySetInnerHTML={{ __html: sanitizePreviewHtml(item.abstract) }}
            
          />
            
          
       
      </CardBox>
      </div>}
      {
        item.projectType === 2 && itemLangList.map(itemLang=>      <CardBox
          styleName="col-md-12 col-12" key={"sas"+itemLang.id}
          heading={<IntlMessages id="item.abstract" />}
        >
      {itemLang.lang}
            <span
              className="card-text"
              dangerouslySetInnerHTML={{ __html: sanitizePreviewHtml(itemLang.langAbstract) }}
              
            />
              
            
         
        </CardBox>)
      }
          <div className="row">
          <CardBox
            styleName="col-md-12 col-12"
            heading={item.projectType===1 ?  (stripPlainText(item.title) + ( item.definition !== "" ? "   ("+stripPlainText(item.definition)+")" :"")): item.isSuggest ? "Gerekçe" : <IntlMessages id="item.itemText" /> } 
          >
        
      
              <span
                className="card-text"
                dangerouslySetInnerHTML={{ __html: sanitizePreviewHtml(item.itemText) }} 
                
              />
              
             
                
              
           
          </CardBox>
          </div>

     { item.projectType ===1 && <div className="row">
      <CardBox
        styleName="col-md-12 col-12"
        heading={<IntlMessages id="item.langItemText" />}
      >
    <div>{itemLang !== null && item.projectType ===1 ?
                    itemLang.map((item,index)=><ItemLangCard index={index} item={item} />)

    : itemLangList.length>0 && item.projectType ===1 ? 
   itemLangList.map((item,index)=><ItemLangCard index={index} item={item} />)
    :
          null } </div>
            
          
       
      </CardBox>
      </div>}

   {(item.projectType ===2)  ?
                    itemLangList.map((item,index)=>  
      <CardBox
        styleName="col-md-12 col-12"
        heading={<IntlMessages id="item.langItemText" /> }
      >
        {item.lang}
    <div>
                    <span
                    className="card-text"
                    dangerouslySetInnerHTML={{ __html: sanitizePreviewHtml(item.langItemText) }}
                    
                  /> 
   </div>
            
          
       
      </CardBox>
     ) : " "}

   
      <div className="row">
      <CardBox
        styleName="col-md-12 col-12"
        heading={<IntlMessages id="item.sourceText" />}
      >
    
          <span
            className="card-text"
            dangerouslySetInnerHTML={{ __html: sanitizePreviewHtml(item.sourceText) }}
            
          />
            
          
       
      </CardBox>
      </div>
   
    </CardContent>
  </Card>;
};

export default ItemPreviewCard;